export enum StateDashboardTiles {
  Gender = 'genderDemographic',
  Enrollment = 'enrollment',
  Age = 'ageBasedOnDob',
  Race = 'childByRace',
  AgeGroup = 'ageGroup',
  Program = 'programByAgeGroup',
}
